var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hc-modern-form-page"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('Card',{attrs:{"title":'Tambah Kupon',"card-class":"hc-form-card"},scopedSlots:_vm._u([{key:"body",fn:function(){return [_c('Form',{attrs:{"form":_vm.form,"route":'coupons'}})]},proxy:true}])})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }